<template>
  <view>
    <slot />
    <!-- <GoodsAttr ref="goodsAttr" /> -->
  </view>
</template>

<script lang="ts" setup>
// import GoodsAttr from '../components/goods/attr.vue'

// 每个页面都会加载GoodsAttr，并且页面在分篇加载重绘的时候，这个也会随之加载，组件下的 /static/icon/icon_close.png 在每次回流都重新加载，浏览器进程堵塞
// 实际测试 加载了60个小组件 ipad用了16s。注释掉组建后变为1.8秒

import propsConfig from '@/uni_modules/thorui/tui-config/index.js'
uni.$tui = propsConfig

// TODO: 测试用，后续删除
// const goodsAttr = ref<InstanceType<typeof GoodsAttr>>()
// onMounted(() => {
//   goodsAttr.value.onSetVisible(true)
// })
</script>
